import React from "react";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import 'tippy.js/themes/light.css';

const Tooltip = ({ children, content }) => {
    return (
        <Tippy theme="light" content={content} className="text-xs p-2 leading-4">
            <div>{children}</div>
        </Tippy>
    );
};

export default Tooltip;
